/**
 * Sesión del usuario del POS web (admin/manager/cashier/waiter de tenant)
 * en localStorage. Mismo modelo que admin pero con role del tenant en
 * lugar de superadmin.
 *
 * Trade-off de localStorage vs cookie httpOnly: ver `apps/admin/src/auth/session.ts`.
 */

const KEY = 'atreus.pos.session.v1';

export type PosUserRole = 'admin' | 'manager' | 'cashier' | 'waiter';

export interface PosSession {
  accessToken: string;
  accessExpiresAt: number;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    fullName: string;
    role: PosUserRole;
  };
  tenantId: string;
  tenantName: string;
  savedAt: number;
}

export const loadSession = (): PosSession | null => {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PosSession;
    if (!parsed.accessToken || !parsed.refreshToken) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveSession = (session: PosSession): void => {
  window.localStorage.setItem(KEY, JSON.stringify(session));
};

export const clearSession = (): void => {
  window.localStorage.removeItem(KEY);
};
